export default __webpack_public_path__ + "static/media/ct2.1.258f2269.png";